<template>
  <div class="page hours">
    <div class="top">
      <div>
        <div class="icon"><i class="fa-solid fa-hourglass-half"></i></div>
        <div class="title"><span>Horarios</span></div>
      </div>
    </div>
    <div class="content">
      <div class="title">Hoje</div>
      <template v-if="!store.schedule.loaded">
        <div class="box" v-for="i in 4" :key="i">
          <Sk w="60px" h="100px" rounded="rounded-lg" extra="mx-auto" />
          <Sk w="70px" h="13px" rounded="rounded-full" extra="mx-auto mt-2" />
          <Sk w="50px" h="11px" rounded="rounded-full" extra="mx-auto mt-1" />
        </div>
      </template>
      <div class="box" v-else :class="{ 'autodj': h.isAutoDJ }" v-for="(h,index) in hours" :key="index">
        <div class="avatar"
             :style="h.isAutoDJ
               ? { backgroundImage: 'none' }
               : { backgroundImage: `url('${avatarUrl(h.user, { headonly: 0 })}')` }">
          <span v-if="h.isAutoDJ" class="autodj-icon">🎵</span>
        </div>
        <div class="nick" @click="() => { if (!h.isAutoDJ) { showP = true; perfilName = h.user } }">{{ h.user }}</div>
        <div class="hour">{{ String(h.start).padStart(2,'0') }}:00</div>
      </div>
      <div class="title two">Amanhã</div>
      <div class="box" :class="{ 'autodj': h.isAutoDJ }" v-for="(h,index) in hours2" :key="index">
        <div class="avatar"
             :style="h.isAutoDJ
               ? { backgroundImage: 'none' }
               : { backgroundImage: `url('${avatarUrl(h.user, { headonly: 0 })}')` }">
          <span v-if="h.isAutoDJ" class="autodj-icon">🎵</span>
        </div>
        <div class="nick" @click="() => { if (!h.isAutoDJ) { showP = true; perfilName = h.user } }">{{ h.user }}</div>
        <div class="hour">{{ String(h.start).padStart(2,'0') }}:00</div>
      </div>
    </div>
    <Transition name="slide-fade">
      <ItemPerfil v-if="showP" @close="showP = false" :user="perfilName" />
    </Transition>
  </div>
</template>

<script setup>

import { avatarUrl } from '@/services/api.js'
import ItemPerfil from '@/components/modals/perfil.vue'
import Sk from '@/components/usefulness/Sk.vue'
import { computed, onMounted, ref } from 'vue'
import { useStore } from '@/stores/index.js'

const store = useStore()

function withLiveDj(slots) {
  if (!slots?.length || !store.radio.name) return slots ?? []
  const out = slots.map((h) => ({ ...h }))
  out[0] = { ...out[0], user: store.radio.name, isAutoDJ: false }
  return out
}

const hours  = computed(() => withLiveDj(store.schedule.hours))
const hours2 = computed(() => store.schedule.hours2)
const showP = ref(false)
const perfilName = ref('')

onMounted(() => {
  if (!store.schedule.loaded) store.loadSchedule()
  if (!store.radio.name) store.player()
})

</script>

<style scoped>
.hours .top .icon {
  background-image: none;
  text-align: center;
  line-height: 34px;
  background-color: #21415C;
}

.hours .content .title {
  width: 100%;
  height: 20px;
  float: left;
  font-size: 14px;
  font-weight: 500;
  padding: 0 10px;
  margin-top: 6px;
}

.hours .content .title.two {
  margin-top: 20px;
}

.hours .content .box {
  position: relative;
  width: calc(100% / 4 - 10px);
  height: 196px;
  float: left;
  margin: 8px 5px 0 5px;
  border-radius: 12px;
  background-color: var(--color1);
  color: #fff;
}

.hours .content .box .avatar {
  position: relative;
  float: left;
  width: 60px;
  height: 110px;
  margin: 10px 0 0 50%;
  transform: translateX(-50%);
  background-repeat: no-repeat;
  background-position: center -20px;
}

.hours .content .box .nick {
  position: relative;
  float: left;
  width: auto;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  background-color: rgba(0, 0, 0, .15);
  transform: translateX(-50%);
  margin: 10px 0 0 50%;
  border-radius: 6px;
  white-space: nowrap;
  padding: 0 10px;
}

.hours .content .box .hour {
  float: left;
  width: 100%;
  height: 30px;
  border-radius: 0 0 12px 12px;
  background-color: rgba(0, 0, 0, .15);
  margin-top: 6px;
  line-height: 30px;
  text-align: center;
  font-weight: 500;
  font-size: 14px;
}

.hours .content .box.autodj {
  opacity: 0.55;
  background-color: var(--color1);
}

.hours .content .box.autodj .nick {
  cursor: default;
  font-style: italic;
  opacity: 0.8;
}

.hours .content .box .avatar {
  display: flex;
  align-items: center;
  justify-content: center;
}

.hours .content .box .autodj-icon {
  font-size: 36px;
  line-height: 1;
  margin-top: 20px;
}
</style>
